import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { makeStyles } from "@material-ui/core/styles";
import { Animated } from "react-animated-css";
import ButtonAtm from "../../../../../atomic/Button/Button";
import PageHeaderAtm from "../../../../../atomic/PageHeader/PageHeader";
import { PageTitle } from "../../../../../atomic/PageHeader/PageTitle";
import { Tooltip } from '@material-ui/core';
import Select from "@material-ui/core/Select";
import {MenuItem} from '@material-ui/core';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { WEB_EDIT_SHORT, WEB } from "../../../../../../constants/appUrls.constants";
import { GET_WEB, OPEN_AI } from "../../../../../../constants/api.constants";
import { getAppLang, getProperty, isDefined, getUserToken } from "../../../../../../utils";
import { getMetaList, getMetaTagList, getMetaTagMapping,
         syncMetaTag, clearMetaTagSync } from "../../../../../../redux/actions/Web/MetaTag/metaTagActions";
import { getLanguages } from "../../../../../../redux/actions/languageActions";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    sidebar: {
        borderRadius: 12,
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: '1px solid #eaedf3',
    },
    sidebarHeader: {
        padding: '14px 20px',
        background: 'linear-gradient(135deg, #d71f26 0%, #df323c 100%)',
        color: '#fff',
        fontWeight: 600,
        fontSize: 14,
        letterSpacing: 0.3,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    pageList: {
        padding: 0,
        maxHeight: 'calc(100vh - 280px)',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d0d0d0',
            borderRadius: 4,
        },
    },
    pageItem: {
        padding: '11px 20px',
        cursor: 'pointer',
        borderLeft: '3px solid transparent',
        transition: 'all 0.2s ease',
        '&:hover': {
            background: '#f8f9fc',
        },
    },
    pageItemActive: {
        background: '#f0f2ff !important',
        borderLeft: '3px solid #d71f26 !important',
        '& .MuiListItemText-primary': {
            fontWeight: 600,
            color: '#d71f26',
        },
    },
    pageIcon: {
        minWidth: 24,
        color: '#b0b7c3',
    },
    pageIconActive: {
        minWidth: 24,
        color: '#d71f26',
    },
    contentPanel: {
        borderRadius: 12,
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: '1px solid #eaedf3',
    },
    contentHeader: {
        padding: '14px 20px',
        background: '#fff',
        borderBottom: '1px solid #eaedf3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    contentHeaderTitle: {
        fontWeight: 600,
        fontSize: 15,
        color: '#2d3748',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    tagChipsArea: {
        padding: '16px 20px',
        background: '#fafbfc',
        borderBottom: '1px solid #eaedf3',
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
    },
    tagChip: {
        borderRadius: 20,
        fontWeight: 500,
        fontSize: 15,
        padding: '0 4px',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        letterSpacing: "0.8px"
    },
    tagChipActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #df323c 100%) !important',
        color: '#fff !important',
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.35)',
    },
    langTabsBar: {
        background: '#fff',
        boxShadow: 'none',
        borderBottom: '2px solid #eaedf3',
        color: "#000"
    },
    langTab: {
        textTransform: 'none',
        minWidth: 107,
        fontWeight: 500,
        fontSize: 13,
        opacity: 0.7,
        '&.Mui-selected': {
            opacity: 1,
            fontWeight: 600,
        },
    },
    langTabIndicator: {
        backgroundColor: '#d71f26',
        height: 3,
        borderRadius: '3px 3px 0 0',
    },
    flagImg: {
        width: 30,
        height: 24,
        borderRadius: 2,
        objectFit: 'cover',
        marginRight: 10,
        // boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    },
    tabPanelContent: {
        padding: '20px 24px',
    },
    breadcrumb: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginBottom: 2,
        fontSize: 12,
        color: '#8492a6',
        '& span': {
            padding: '2px 8px',
            background: '#f0f2f5',
            borderRadius: 4,
            fontWeight: 500,
        },
    },
    inputField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            background: '#fafbfc',
            transition: 'all 0.2s ease',
            '&:hover': {
                background: '#f5f6f8',
            },
            '&.Mui-focused': {
                background: '#fff',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d71f26',
                    borderWidth: 2,
                },
            },
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#d71f26',
        },
    },
    charCounter: {
        textAlign: 'right',
        fontSize: 12,
        color: '#000',
        marginTop: 4,
    },
    saveArea: {
        padding: '16px 24px',
        borderTop: '1px solid #eaedf3',
        display: 'flex',
        justifyContent: 'flex-end',
        background: '#fafbfc',
    },
    saveBtn: {
        background: '#d71f26',
        color: '#fff',
        borderRadius: 10,
        padding: '8px 32px',
        fontWeight: 600,
        textTransform: 'none',
        fontSize: 14,
        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.35)',
        '&:hover': {
            boxShadow: '0 4px 14px rgba(102, 126, 234, 0.45)',
            background: "#d71f26"
        },
        '&:disabled': {
            opacity: 0.6,
        },
    },
    emptyState: {
        padding: '60px 24px',
        textAlign: 'center',
        color: '#a0aec0',
        background: '#fff',
    },
    emptyIcon: {
        fontSize: 48,
        marginBottom: 16,
        opacity: 0.4,
    },
    loadingOverlay: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: theme.zIndex.drawer + 1,
    },
    detailSelectArea: {
        padding: '16px 20px',
        background: '#fff',
        borderBottom: '1px solid #eaedf3',
    },
    detailSelect: {
        borderRadius: 10,
        background: '#fafbfc',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#eaedf3',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d71f26',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d71f26',
            borderWidth: 2,
        },
    },
    detailMenuItem: {
        fontSize: 14,
        '&.Mui-selected': {
            background: '#f0f2ff',
            fontWeight: 600,
            color: '#d71f26',
        },
        '&.Mui-selected:hover': {
            background: '#e8eaff',
        },
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`meta-lang-tabpanel-${index}`}
            aria-labelledby={`meta-lang-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `meta-lang-tab-${index}`,
        'aria-controls': `meta-lang-tabpanel-${index}`,
    };
}

export default function MetaTagIndex() {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const metaTagState = useSelector(state => state?.metaTagReducer);
    const languageList = useSelector(state => state?.languagesReducer?.languages);

    const [backUrl, setBackUrl] = useState(null);
    const [propertyWebId, setPropertyWebId] = useState(null);
    const [selectedMeta, setSelectedMeta] = useState(null);
    const [selectedMetaTag, setSelectedMetaTag] = useState(null);
    const [langTabValue, setLangTabValue] = useState(0);
    const [formData, setFormData] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [saving, setSaving] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);

    const [translateLoading, setTranslateLoading] = useState(false);

    useEffect(() => {
        dispatch(getMetaList());
        dispatch(getMetaTagList());
        dispatch(getLanguages());
        getBackUrl();
    }, [dispatch]);

    useEffect(() => {
        if (isDefined(selectedMeta) && isDefined(selectedMetaTag)) {
            const hasDetail = Array.isArray(selectedMeta?.detail) && selectedMeta.detail.length > 0;
            if (hasDetail && !isDefined(selectedDetail)) return;

            const filter = {
                property_web_meta_id: String(selectedMeta?.id),
                property_web_meta_tag_id: String(selectedMetaTag?.id),
            };
            if (hasDetail && isDefined(selectedDetail)) {
                filter.code = String(selectedDetail.code);
            }
            dispatch(getMetaTagMapping(filter));
        }
    }, [dispatch, selectedMeta, selectedMetaTag, selectedDetail]);



    useEffect(() => {
        if (!Array.isArray(metaTagState?.metaTagMapping) || !Array.isArray(languageList)) return;
        const entry = metaTagState.metaTagMapping[0];
        const textArray = Array.isArray(entry?.textArray) ? entry.textArray : [];
        const newFormData = {};
        languageList.forEach(lang => {
            if (!isDefined(lang?.code)) return;
            const mapping = textArray.find(m => m?.language_code === lang?.code);
            newFormData[lang?.code] = isDefined(mapping?.content) ? mapping?.content : '';
        });
        setFormData(newFormData);
    }, [metaTagState?.metaTagMapping, languageList]);

    useEffect(() => {
        if (isDefined(metaTagState?.syncData) && !metaTagState?.syncError) {
            setSaving(false);
            setSnackbar({ open: true, message: t('enw-notification_saved_successfully'), severity: 'success' });
            if (isDefined(selectedMeta) && isDefined(selectedMetaTag)) {
                const hasDetail = Array.isArray(selectedMeta?.detail) && selectedMeta.detail.length > 0;
                const filter = {
                    property_web_meta_id: String(selectedMeta?.id),
                    property_web_meta_tag_id: String(selectedMetaTag?.id),
                };
                if (hasDetail && isDefined(selectedDetail)) {
                    filter.code = String(selectedDetail.code);
                }
                dispatch(getMetaTagMapping(filter));
            }
            dispatch(clearMetaTagSync());
        }
        if (metaTagState?.syncError) {
            setSaving(false);
            setSnackbar({ open: true, message: t('enw-error-message'), severity: 'error' });
            dispatch(clearMetaTagSync());
        }
    }, [metaTagState?.syncData, metaTagState?.syncError]);

    const getBackUrl = () => {
        const params = { params: { property_id: getProperty() } };
        axios.post(GET_WEB, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            if (isDefined(result?.data?.data?.status)) {
                setBackUrl(result.data?.data?.id);
                setPropertyWebId(result.data?.data?.id);
            }
        }).catch(() => {});
    };

    const handleMetaSelect = (meta) => {
        if (!isDefined(meta)) return;
        setSelectedMeta(meta);
        setSelectedDetail(null);
        const hasDetail = Array.isArray(meta?.detail) && meta.detail.length > 0;
        if (!hasDetail) {
            const titleTag = metaTagList.find(tag => tag?.name === 'title');
            setSelectedMetaTag(titleTag || null);
        } else {
            setSelectedMetaTag(null);
        }
        setFormData({});
        setLangTabValue(0);
    };

    const handleDetailSelect = (detail) => {
        if (!isDefined(detail)) return;
        setSelectedDetail(detail);
        const titleTag = metaTagList.find(tag => tag?.name === 'title');
        setSelectedMetaTag(titleTag || null);
        setFormData({});
        setLangTabValue(0);
    };

    const handleMetaTagSelect = (tag) => {
        if (!isDefined(tag)) return;
        setSelectedMetaTag(tag);
        setLangTabValue(0);
    };

    const handleInputChange = (langCode, value) => {
        if (!isDefined(langCode)) return;
        setFormData(prev => ({ ...prev, [langCode]: value }));
    };

    const handleSave = () => {
        if (!isDefined(selectedMeta) || !isDefined(selectedMetaTag) || !isDefined(propertyWebId)) return;
        const hasDetail = Array.isArray(selectedMeta?.detail) && selectedMeta.detail.length > 0;
        if (hasDetail && !isDefined(selectedDetail)) return;
        if (!Array.isArray(languageList) || languageList.length === 0) return;

        const text = languageList
            .filter(lang => isDefined(lang?.code) && formData[lang?.code] !== undefined)
            .map(lang => ({
                language_code: lang?.code,
                content: formData[lang?.code] || '',
            }));

        setSaving(true);
        dispatch(syncMetaTag({
            property_web_id: propertyWebId,
            property_web_meta_id: selectedMeta?.id,
            property_web_meta_tag_id: selectedMetaTag?.id,
            code: hasDetail && selectedDetail ? selectedDetail.code : null,
            text,
        }));
    };

    const sortedLanguages = Array.isArray(languageList) ? [...languageList].sort((a, b) => {
        if (a?.code === "tr") return -1;
        if (b?.code === "tr") return 1;
        if (a?.code === "en") return -1;
        if (b?.code === "en") return 1;
        return (a?.code || "").localeCompare(b?.code || "");
    }) : [];

    const isLoading = metaTagState?.metaListFetching || metaTagState?.metaTagListFetching;
    const metaList = Array.isArray(metaTagState?.metaList) ? metaTagState.metaList : [];
    const metaTagList = Array.isArray(metaTagState?.metaTagList) ? metaTagState.metaTagList : [];

    const getMaxLength = (tagName) => {
        if (tagName === 'content') return 320;
        if (tagName === 'keywords') return 500;
        return 160;
    };

    const isDescription = isDefined(selectedMetaTag) && selectedMetaTag?.name === 'content';
    const hasDetail = Array.isArray(selectedMeta?.detail) && selectedMeta.detail.length > 0;

    const handleTranslate = (langCode) => async () => {
        const currentText = formData[langCode];
        if (!currentText || currentText.trim() === "") return;

        setTranslateLoading(true);

        const sourceLangName = (languageList || []).find(lang => lang?.code === langCode)?.name || langCode;

        const targetLangs = (languageList || [])
            .map(lang => ({ code: lang?.code, name: lang?.name }))
            .filter(lang => lang.code);

        const headers = {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        };

        const makeRequest = (targetLang) => {
            const body = {
                params: {
                    property_id: getProperty(),
                    query: {
                        model: "gpt-4.1-mini",
                        response_format: { type: "json_object" },
                        messages: [
                            {
                                role: "system",
                                content: "Sen profesyonel bir çevirmensin. Cevabını SADECE JSON formatında ver, tek bir key olsun: dil kodu (örn: {\"en\": \"...\"})."
                            },
                            {
                                role: "user",
                                content: `Aşağıdaki ${sourceLangName} dilindeki metni ${targetLang.name} diline çevir. Metin: "${currentText}". Çeviriyi JSON formatında ver, key olarak "${targetLang.code}" kullan.`
                            }
                        ]
                    }
                }
            };
            return axios.post(OPEN_AI, body, { headers }).then(res => res.data.data).catch(() => null);
        };

        try {
            const results = await Promise.all(targetLangs.map(lang => makeRequest(lang)));
            const merged = {};
            results.forEach(result => {
                if (result && typeof result === 'object') {
                    Object.assign(merged, result);
                }
            });

            setFormData(prev => {
                const updated = { ...prev };
                Object.keys(merged).forEach(lang => {
                    if (lang !== langCode && merged[lang]) {
                        updated[lang] = merged[lang];
                    }
                });
                return updated;
            });
            setSnackbar({ open: true, message: t('enw-translated_to_all_languages'), severity: 'success' });
        } finally {
            setTranslateLoading(false);
        }
    };

    return (
        <Fragment>
            <style>{`
                button.Mui-disabled {
                    color:#000 !important;
                }
                .meta-text-field {
                    margin-top:0px !important;
                }
                .meta-select-box {
                    margin-bottom:8px !important;
                    margin-top:8px !important;
                }
            `}</style>
            <PageTitle title={t('btn-meta_tag_management')} />
            <PageHeaderAtm
                exitText={t('enw-web-edit-page_title')}
                backButton={backUrl === null ? WEB : WEB_EDIT_SHORT + backUrl}
                text={t('btn-meta_tag_management')}
            />
            <Animated animationIn="fadeIn" isVisible={true}>
                <Container maxWidth="xl">
                    <Grid container spacing={3} className={classes.root}>
                        {isLoading ? (
                            <Grid item xs={12} className={classes.loadingOverlay} style={{ textAlign: 'center', padding: 60 }}>
                                <CircularProgress style={{ color: '#d71f26' }} />
                            </Grid>
                        ) : (
                            <Fragment>
                                {/* Sol Panel */}
                                <Grid item xs={12} md={3}>
                                    <Paper className={classes.sidebar} elevation={0}>
                                        <Box className={classes.sidebarHeader}>
                                            <i className="fas fa-layer-group" />
                                            {t('enw-meta-pages')}
                                        </Box>
                                        <List className='meta-page-list' disablePadding>
                                            {metaList.map((meta) => (
                                                <ListItem
                                                    key={meta.id}
                                                    button
                                                    className={`${classes.pageItem} ${selectedMeta?.id === meta.id ? classes.pageItemActive : ''}`}
                                                    onClick={() => handleMetaSelect(meta)}
                                                    divider
                                                >
                                                    <ListItemIcon className={selectedMeta?.id === meta.id ? classes.pageIconActive : classes.pageIcon}>
                                                        <i className="fas fa-file-alt" style={{ fontSize: 14 }} />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={meta.name}
                                                        primaryTypographyProps={{ style: { fontSize: 14 } }}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Paper>
                                </Grid>

                                {/* Sağ Panel */}
                                <Grid item xs={12} md={9}>
                                    {!isDefined(selectedMeta) ? (
                                        <Paper className={classes.contentPanel} elevation={0}>
                                            <Box className={classes.emptyState}>
                                                <i className={`fas fa-mouse-pointer ${classes.emptyIcon}`} />
                                                <Typography variant="body1" style={{ fontWeight: 500, color: '#718096' }}>
                                                    {t('enw-meta-select-page')}
                                                </Typography>
                                                <Typography variant="body2" style={{ marginTop: 8, color: '#a0aec0' }}>
                                                    {t('enw-meta-select-page-desc') || ''}
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    ) : (
                                        <Paper className={classes.contentPanel} elevation={0}>
                                            {/* Header */}
                                            <Box className={classes.contentHeader}>
                                                <Box className={classes.contentHeaderTitle}>
                                                    <i className="fas fa-code" style={{ color: '#d71f26', fontSize: 16 }} />
                                                    {selectedMeta.name}
                                                </Box>
                                                <Chip
                                                    size="small"
                                                    label={t('enw-meta-tags')}
                                                    style={{
                                                        background: '#eef2ff',
                                                        color: '#d71f26',
                                                        fontWeight: 600,
                                                        fontSize: 11,
                                                    }}
                                                />
                                            </Box>

                                            {/* Detail Selection */}
                                            {Array.isArray(selectedMeta?.detail) && selectedMeta.detail.length > 0 && (
                                                <Box className={classes.detailSelectArea}>
                                                    <FormControl variant="outlined" className='meta-select-box' fullWidth size="small">
                                                        <InputLabel style={selectedDetail ? { color: '#d71f26' } : {}}>
                                                            {t('enw-meta-select-detail')}
                                                        </InputLabel>
                                                        <Select
                                                            value={selectedDetail?.code || ''}
                                                            onChange={(e) => {
                                                                const detail = selectedMeta.detail.find(d => d.code === e.target.value);
                                                                handleDetailSelect(detail);
                                                            }}
                                                            label={t('enw-meta-select-detail')}
                                                            className={classes.detailSelect}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    style: { maxHeight: 300, borderRadius: 10 },
                                                                },
                                                            }}
                                                        >
                                                            {selectedMeta.detail.map((d) => (
                                                                <MenuItem key={d.code} value={d.code} className={classes.detailMenuItem}>
                                                                    {d.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            )}

                                            {/* Detail seçilmemiş uyarısı */}
                                            {Array.isArray(selectedMeta?.detail) && selectedMeta.detail.length > 0 && !isDefined(selectedDetail) && (
                                                <Box className={classes.emptyState} style={{ padding: '40px 24px' }}>
                                                    <i className="fas fa-list-ul" style={{ fontSize: 32, marginBottom: 12, opacity: 0.3 }} />
                                                    <Typography variant="body2" style={{ color: '#a0aec0' }}>
                                                        {t('enw-meta-select-detail')}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* Tag Chips */}
                                            {metaTagList.length > 0 && (!hasDetail || isDefined(selectedDetail)) && (
                                                <Box className={classes.tagChipsArea + " mobile-tag-chips"}>
                                                    {metaTagList.map((tag) => (
                                                        <Chip
                                                            key={tag.id}
                                                            label={isDefined(tag?.name) ? tag.name.charAt(0).toUpperCase() + tag.name.slice(1) : ''}
                                                            className={`${classes.tagChip + " mobile-tag-chip"} ${selectedMetaTag?.id === tag.id ? classes.tagChipActive : ''}`}
                                                            variant={selectedMetaTag?.id === tag.id ? "default" : "outlined"}
                                                            onClick={() => handleMetaTagSelect(tag)}
                                                            icon={
                                                                <i
                                                                    className={
                                                                        tag.name === 'title' ? 'fas fa-heading' :
                                                                        tag.name === 'content' ? 'fas fa-align-left' :
                                                                        tag.name === 'keywords' ? 'fas fa-key' :
                                                                        'fas fa-tag'
                                                                    }
                                                                    style={{
                                                                        fontSize: 12,
                                                                        color: selectedMetaTag?.id === tag.id ? '#fff' : '#d71f26',
                                                                        marginLeft: 8,
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    ))}
                                                </Box>
                                            )}

                                            {/* Dil Tabları ve İçerik */}
                                            {isDefined(selectedMetaTag) && sortedLanguages.length > 0 && (!hasDetail || isDefined(selectedDetail)) ? (
                                                <Box>
                                                    {metaTagState?.metaTagMappingFetching ? (
                                                        <Box style={{ textAlign: 'center', padding: 50 }}>
                                                            <CircularProgress size={28} style={{ color: '#d71f26' }} />
                                                        </Box>
                                                    ) : (
                                                        <Fragment>
                                                            <AppBar position="static" className={classes.langTabsBar} elevation={0}>
                                                                <Tabs
                                                                    value={langTabValue}
                                                                    onChange={(e, newVal) => setLangTabValue(newVal)}
                                                                    aria-label="meta-lang-tabs"
                                                                    variant="scrollable"
                                                                    scrollButtons="on"
                                                                    classes={{ indicator: classes.langTabIndicator }}
                                                                >
                                                                    {sortedLanguages.map((lang, index) => (
                                                                        <Tab
                                                                            key={lang?.code || index}
                                                                            className={classes.langTab}
                                                                            label={
                                                                                <Box display="flex" alignItems="center" style={{color: "#000000de"}}>
                                                                                    <img
                                                                                        src={`${process.env.PUBLIC_URL}/assets/img/language/${lang?.code || ''}.svg`}
                                                                                        alt={lang?.code || ''}
                                                                                        className={classes.flagImg}
                                                                                    />
                                                                                    {lang?.code?.toUpperCase() || ''}
                                                                                </Box>
                                                                            }
                                                                            {...a11yProps(index)}
                                                                        />
                                                                    ))}
                                                                </Tabs>
                                                            </AppBar>

                                                            {sortedLanguages.map((lang, index) => (
                                                                <TabPanel value={langTabValue} index={index} key={lang?.code || index}>
                                                                    <Box className={classes.tabPanelContent}>
                                                                        <Box className={classes.breadcrumb}>
                                                                            <span>{selectedMeta?.name || ''}</span>
                                                                            {hasDetail && isDefined(selectedDetail) && (
                                                                                <Fragment>
                                                                                    <i className="fas fa-chevron-right" style={{ fontSize: 8 }} />
                                                                                    <span style={{ background: '#eef2ff', color: '#d71f26' }}>{selectedDetail.name}</span>
                                                                                </Fragment>
                                                                            )}
                                                                            <i className="fas fa-chevron-right" style={{ fontSize: 8 }} />
                                                                            <span>{isDefined(selectedMetaTag?.name) ? selectedMetaTag.name.charAt(0).toUpperCase() + selectedMetaTag.name.slice(1) : ''}</span>
                                                                            <i className="fas fa-chevron-right" style={{ fontSize: 8 }} />
                                                                            <span style={{ background: '#eef2ff', color: '#d71f26' }}>
                                                                                {lang?.code?.toUpperCase() || ''}
                                                                            </span>
                                                                        </Box>
                                                                        <Box display="flex" className='mt-20-m' justifyContent="flex-end" mb={1}>
                                                                            <ButtonAtm
                                                                                size="small"
                                                                                variant="outlined"
                                                                                onClick={handleTranslate(lang?.code)}
                                                                                startIcon={
                                                                                    translateLoading ?
                                                                                        <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                                                                        :
                                                                                        <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20, marginLeft: "8px"}} viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/>
                                                                                        </svg>
                                                                                }
                                                                                style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                                                                                buttontext={t('btn-translate')}
                                                                                disabled={!isDefined(formData[lang?.code]) || formData[lang?.code].trim() === "" || translateLoading || saving}
                                                                            />
                                                                        </Box>
                                                                        <TextField
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            className={classes.inputField + " meta-text-field"}
                                                                            multiline={isDescription}
                                                                            rows={isDescription ? 4 : 2}
                                                                            label={`${isDefined(selectedMetaTag?.name) ? selectedMetaTag.name.charAt(0).toUpperCase() + selectedMetaTag.name.slice(1) : ''} — ${lang?.code?.toUpperCase() || ''}`}
                                                                            placeholder={`${isDefined(selectedMetaTag?.name) ? selectedMetaTag.name.charAt(0).toUpperCase() + selectedMetaTag.name.slice(1) : ''}...`}
                                                                            value={isDefined(formData[lang?.code]) ? formData[lang.code] : ''}
                                                                            onChange={(e) => handleInputChange(lang?.code, e.target.value)}
                                                                            inputProps={{
                                                                                maxLength: getMaxLength(selectedMetaTag?.name)
                                                                            }}
                                                                        />
                                                                        <Typography className={classes.charCounter}>
                                                                            {(isDefined(formData[lang?.code]) ? formData[lang.code] : '').length} / {getMaxLength(selectedMetaTag?.name)}
                                                                        </Typography>
                                                                    </Box>
                                                                </TabPanel>
                                                            ))}

                                                            <Box className={classes.saveArea}>
                                                                <ButtonAtm
                                                                    className={classes.saveBtn}
                                                                    buttontext={saving ? (
                                                                        <CircularProgress size={20} style={{ color: '#fff' }} />
                                                                    ) : (t('btn-save'))}
                                                                    style={saving ? { height: "40px" } : undefined}
                                                                    onClick={handleSave}
                                                                    disabled={saving || translateLoading}
                                                                />
                                                            </Box>
                                                        </Fragment>
                                                    )}
                                                </Box>
                                            ) : (
                                                !isDefined(selectedMetaTag) && (!hasDetail || isDefined(selectedDetail)) && (
                                                    <Box className={classes.emptyState} style={{ padding: '40px 24px' }}>
                                                        <i className="fas fa-hand-pointer" style={{ fontSize: 32, marginBottom: 12, opacity: 0.3 }} />
                                                        <Typography variant="body2" style={{ color: '#a0aec0' }}>
                                                            {t('enw-meta-select-tag')}
                                                        </Typography>
                                                    </Box>
                                                )
                                            )}
                                        </Paper>
                                    )}
                                </Grid>
                            </Fragment>
                        )}
                    </Grid>
                </Container>
            </Animated>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                    severity={snackbar.severity}
                    variant="filled"
                    style={{ borderRadius: 10 }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Fragment>
    );
}